import type { Payment, PaymentForm } from "../../../../common/types/payment";
import httpRequest from ".";
import { BaseService } from "./baseService";
import { CUSTOM_PAY_TYPE } from "@zhihaoscm/meta";

export class PaymentService extends BaseService<Payment, any, any, PaymentForm> {
    /**
     * 创建实例
     * @param form
     */
    public async create(form: PaymentForm): Promise<Payment> {
        const _form = {
            ...form,
            detail: JSON.stringify(form.detail)
        };
        const { data } = await this.service.post(this.path, _form);
        return data;
    }
    /**获取支付二维码 */
    async getQRCode(params: { payType: number; outTradeNo: string; type: number }) {
        const { data } = await this.service.get(`${this.path}/code`, { params });
        return data;
    }

    /**获取订单状态 */
    async getState(outTradeNo: string) {
        const { data } = await this.service.get(`${this.path}/state`, {
            params: { outTradeNo, payType: CUSTOM_PAY_TYPE.CHINAUMS.code }
        });
        return data;
    }
}

export const paymentService = new PaymentService("/payment", httpRequest);
